import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/** Values supplied when one connector is run. */
export interface RunRequest {
  connectorId: ents.core.integrations.Connector.Id
  truncateModelIds: readonly ents.core.dms.models.ForRecord.Id[]
}

/** Connector-run actions and request lifecycle reducers. */
export function getActionsConfig() {
  return {
    closeLauncher: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => State.withLauncher(state, false),
    }),
    dismiss: store.actions.standalone({
      data: store.actions.Data.asIs<ents.core.integrations.Connector.Id>(),
      reducer: ({ data: connectorId, state }): State =>
        State.withoutEntry(state, connectorId),
    }),
    openLauncher: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => State.withLauncher(state, true),
    }),
    progress: store.actions.standalone({
      data: store.actions.Data.asIs<{
        connectorId: ents.core.integrations.Connector.Id
        run?: ents.core.integrations.Connector.Run
      }>(),
      reducer: ({ data, state }): State =>
        State.withRunProgress(state, data.connectorId, data.run),
    }),
    run: store.actions.request({
      input: store.actions.Data.asIs<RunRequest>(),
      output: store.actions.Data.asIs<true>(),
      reducers: {
        cancellation: ({ data: { request }, state }): State =>
          State.withoutRunRequest(state, request.connectorId),
        error: ({ data: { error, request }, state }): State =>
          State.withRunError(state, request.connectorId, error),
        request: ({ data: request, state }): State =>
          State.withRunRequest(state, request.connectorId),
        success: ({ data: { request }, state }): State =>
          State.withRunSuccess(state, request.connectorId),
      },
    }),
    setTruncation: store.actions.standalone({
      data: store.actions.Data.asIs<{
        connectorId: ents.core.integrations.Connector.Id
        modelId: ents.core.dms.models.ForRecord.Id
        selected: boolean
      }>(),
      reducer: ({ data, state }): State =>
        State.withTruncationSelection(
          state,
          data.connectorId,
          data.modelId,
          data.selected,
        ),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
